export const MEMBER_REQUIRED_FIELD_NAMES = {
  email: 'MEMBER_REQUIRED_EMAIL',
  birthdate: 'MEMBER_REQUIRED_BIRTHDATE',
  address: 'MEMBER_REQUIRED_ADDRESS',
  city: 'MEMBER_REQUIRED_CITY',
  neighborhood: 'MEMBER_REQUIRED_NEIGHBORHOOD',
  emergencyPhone: 'MEMBER_REQUIRED_EMERGENCY_PHONE',
  emergencyRelation: 'MEMBER_REQUIRED_EMERGENCY_RELATION',
  medicalConditions: 'MEMBER_REQUIRED_MEDICAL_CONDITIONS',
  photo: 'MEMBER_REQUIRED_PHOTO',
} as const;

export const MEMBER_REQUIRED_POLICY_TYPE = 'MEMBER_REQUIRED_POLICY';
export const MEMBER_REQUIRED_SUBSCRIPTIONS_CONFIG = 'MEMBER_REQUIRED_SUBSCRIPTIONS';
export const DEFAULT_SUBSCRIPTIONS_BEFORE_REQUIRED_DATA = 3;

export type ConfigurableMemberField = keyof typeof MEMBER_REQUIRED_FIELD_NAMES;
export type MemberRequiredField = ConfigurableMemberField | 'name' | 'lastNames' | 'cellPhone';
export type MemberRequiredFields = Record<MemberRequiredField, boolean>;

export const DEFAULT_MEMBER_REQUIRED_FIELDS: MemberRequiredFields = {
  name: true,
  lastNames: true,
  cellPhone: true,
  email: false,
  birthdate: true,
  address: false,
  city: false,
  neighborhood: false,
  emergencyPhone: true,
  emergencyRelation: true,
  medicalConditions: true,
  photo: false,
};
